import {handleLogout} from "components/utils";
import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {Button, Card, Col, Form, Modal, Row} from "react-bootstrap";
import axios from "axios";
import 'react-vertical-timeline-component/style.min.css';
import {Typeahead} from "react-bootstrap-typeahead";
import Editor from "react-simple-wysiwyg";
import {RichEditor} from "../ipd/consentForms/RichEditor";

export const AddDiagnosticTestView = forwardRef((props: { visitId: string, source: string, uhid: string, entityQr: string, postAction: any, showSave: boolean, category: string, createVisit: any }, ref) => {

    const [successMessage, setSuccessMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [selectedRecordType, setSelectedRecordType] = useState([]);
    const [recordType, setRecordType] = useState<string>();
    const [allowAddingReport, setAllowAddingReport] = useState<boolean>(true);
    const [reportRequired, setReportRequired] = useState<boolean>(true);
    const [diagnosis, setDiagnosis] = useState(null);
    const [file, setFile] = useState<any>();
    const [services, setServices] = useState<Array<any>>();

    let componentRef = useRef(null);


    const handleChange = event => {
        setErrorMessage(null)
        if (event.target.files && event.target.files[0]) {
            const selectedFile = event.target.files[0];
            if (selectedFile.size > 6000000) {
                setErrorMessage("File size should be less than 5 MB")
            } else {
                setFile(selectedFile);
            }
        }
    };

    const handleSelectRecordType = value => {
        setSelectedRecordType(value)
        if (value && value.length > 0) {
            setRecordType(value[0].name)
        }
    };

    function fetchServices() {
        axios.get('/api/backend/inventory/item/fetch/all/' + props.entityQr + "?type=SERVICE")
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                let services = resp.data;
                if (props.category != null) {
                    let filter = "";
                    switch (props.category) {
                        case "RADIOLOGY":
                            filter = "Radiology";
                            break;
                        case "LAB":
                            filter = "Lab";
                            break;
                    }
                    services = resp.data.filter(d => (d.category == filter))
                } else {
                    services = resp.data.filter(d => (d.category == "Radiology" || d.category == "Lab" || d.category == "Medical Services"))
                }
                setServices(services)
                if (resp.data && resp.data.length > 0) setRecordType(services[0].name)
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
            })
    }


    recordType

    useEffect(() => {
        if (recordType) {
            const recordCategory = services.filter(s => s.name == recordType)[0].category
            if (recordCategory == "Radiology" || recordCategory == "Lab") {
                setAllowAddingReport(false)
                setReportRequired(true)
            } else {
                setAllowAddingReport(true)
                setReportRequired(false)
            }
        }

    }, [recordType])

    useEffect(() => {
        if (props.entityQr) {
            fetchServices();
        }

    }, [props.entityQr])

    const uploadFile = async () => {

        let key = props.entityQr + "_" + props.uhid + "_" + props.visitId + "_" + file.name
        let {data} = await axios.post("/api/s3/upload", {
            name: key,
            type: file.type,
        });

        console.log(data);

        const url = data.url;
        let {data: newData} = await axios.put(url, file, {
            headers: {
                "Content-type": file.type,
                "Access-Control-Allow-Origin": "*",
            },
        });

        console.log(newData);

        return key
    };

    useImperativeHandle(ref, () => ({

        handleAddRecord(uhid, visitId) {
            handleAddRecord(null, uhid, visitId)
        }

    }));

    function addRecord(uhid, visitId, itemId) {
        if (file) {
            uploadFile()
                .then(resp => {
                    console.log(resp)
                    axios.post('/api/backend/customer/records/create/' + uhid + '/' + visitId + "?recordType=" + recordType + "&entityQr=" + props.entityQr + "&source=" + props.source + "&diagnosis=" + diagnosis + "&itemId=" + itemId + "&reportRequired=" + reportRequired, {key: resp})
                        .then(resp => {
                            console.log(resp.data)
                            if (props.postAction) {
                                props.postAction(visitId)
                            }
                            setDiagnosis("")
                            setFile(null)
                            setSelectedRecordType([])
                            setReportRequired(false)
                            componentRef.current.value = null
                        })
                        .catch(err => {
                            setErrorMessage("Error while creating the record")
                            console.error(err);
                            if (err.response && err.response!.status && err.response!.status === 403) {
                                handleLogout()
                            }
                            ;
                        }).finally(() => setLoading(false));
                })
                .catch(err => {
                    console.error(err);
                    if (err.response && err.response!.status && err.response!.status === 403) {
                        handleLogout()
                    }
                    ;
                    setErrorMessage("Error while uploading the file")
                }).finally(() => setLoading(false));
        } else {
            axios.post('/api/backend/customer/records/create/' + props.uhid + '/' + visitId + "?recordType=" + recordType + "&entityQr=" + props.entityQr + "&source=" + props.source + "&diagnosis=" + diagnosis + "&itemId=" + itemId + "&reportRequired=" + reportRequired, {})
                .then(resp => {
                    console.log(resp.data)
                    if (props.postAction) {
                        props.postAction(visitId)
                    }
                    setDiagnosis("")
                    setFile(null)
                    setSelectedRecordType([])
                    setReportRequired(false)
                })
                .catch(err => {
                    setErrorMessage("Error while creating the record")
                    console.error(err);
                    if (err.response && err.response!.status && err.response!.status === 403) {
                        handleLogout()
                    }
                    ;
                }).finally(() => setLoading(false));
        }
    }

    const handleAddRecord = async (e, uhid, visitId) => {
        if (e) {
            e.preventDefault()
        }
        setErrorMessage(null)
        setLoading(true)
        const itemId = services.filter(svc => svc.name == recordType)[0].id

        if (!visitId || visitId == null) {
            if (props.createVisit) {
                const visitIdCreated = await props.createVisit();
                addRecord(uhid, visitIdCreated, itemId);
            } else {
                setErrorMessage("No visit to Map the record")
            }
        } else {
            addRecord(uhid, visitId, itemId);
        }
    }

    function getAddNewWidget() {
        return <>
            <div className="mt-3"/>
            <div className="card p-2 bg-light">
                <Form>
                    <div className="row">
                        <div className="col col-12 col-lg-12">
                            <div className="d-flex gap-2 gap-lg-3 justify-content-between my-2">
                                <Typeahead
                                    clearButton
                                    labelKey="name"
                                    className="flex-fill"
                                    selected={selectedRecordType}
                                    onChange={handleSelectRecordType}
                                    options={services}
                                    placeholder="Filter..."
                                    size="sm"
                                />
                                {allowAddingReport && <Form.Check
                                    type="switch"
                                    id="custom-switch"
                                    checked={reportRequired}
                                    className=""
                                    onChange={e => setReportRequired(e.target.checked)}
                                    label="Report Required"
                                />}
                                {props.showSave && <button className="btn btn-warning text-white btn-sm"
                                                           onClick={e => handleAddRecord(e, props.uhid, props.visitId)}>
                                    {loading &&
                                        <div className="text-center">
                                            <div className="spinner-border" role="status">
                                            </div>
                                        </div>
                                    }
                                    {!loading && <div className="fw-bold">+ Add</div>}
                                </button>}
                            </div>
                        </div>
                        {reportRequired && allowAddingReport && <div className="col col-12"><Card className="p-2">
                            <div className="my-2 fs-7 text-success"> * Can be added Later</div>
                            <div className="col col-12">
                                <div className="my-2 d-flex gap-2">
                                    <label className="align-self-center text-info text-nowrap">Report
                                        attachment:</label>
                                    <input type="file"
                                           ref={componentRef}
                                           className="form-control form-select-sm"
                                           accept=".doc,.docx,.HEIC,.HEIC,.HEVC,image/*,application/pdf"
                                           onChange={handleChange}/>
                                </div>
                            </div>
                            <div className="col col-12">
                                <Form.Group className="my-2" controlId="diagnosis">
                                    <label className="align-self-center text-info">Report Details:</label>
                                    <Editor
                                        containerProps={{style: {resize: 'vertical', minHeight: "300px"}}}
                                        value={diagnosis}
                                        onChange={e => setDiagnosis(e.target.value)}
                                        placeholder="Write Notes to be printed on all reports"
                                    />
                                </Form.Group>
                            </div>
                        </Card>
                        </div>}

                        <div className="my-2">
                            {errorMessage &&
                                <div className="text-danger fs-6">*{errorMessage}</div>
                            }
                        </div>
                    </div>

                </Form>
            </div>
        </>;
    }

    return (
        <>
            {getAddNewWidget()}
        </>
    );
});

AddDiagnosticTestView.displayName = "AddDiagnosticTestView";